import React from 'react';
import { SRLWrapper } from 'simple-react-lightbox';
import { SRLWrapperOptions } from '../../utils/utils';
import Masonry from 'react-masonry-css';
import { GatsbyImage } from 'gatsby-plugin-image';

const MasonryGallery = ({ data }) => {
  const breakpoints = {
    default: 3,
    1200: 3,
    768: 2,
    500: 1,
  };
  return (
    <SRLWrapper options={SRLWrapperOptions}>
      <Masonry
        breakpointCols={breakpoints}
        className='my-masonry-grid'
        columnClassName='my-masonry-grid_column'>
        {data.map(({ node }) => {
          return (
            <a href={node.publicURL} key={node.id}>
              <GatsbyImage image={node.childImageSharp.gatsbyImageData} />
            </a>
          );
        })}
      </Masonry>
    </SRLWrapper>
  );
};

export default MasonryGallery;
